import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { EmployeeCacheService } from '../../core/services/employee-cache.service';
import { ToastService } from '../../core/services/toast-service';
import { EmployeePermissionType } from '../models/employee/employee-permissions-type.model';
import { ToastMode } from '../models/toast/toast-mode.enum';

export const CanViewAdminGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const employeeCacheService = inject(EmployeeCacheService);
  const toastService = inject(ToastService);
  const router = inject(Router);
  return employeeCacheService.loaded$.pipe(
    take(1),
    map(() => {
      var hasPermission = employeeCacheService.checkPermissions([EmployeePermissionType.SuperAdmin]);
      if (hasPermission) {
        return true;
      }
      else {
        toastService.show('You do Not have permission to access this page', ToastMode.Danger);
        return router.createUrlTree(['/']);
      }
    })
  );
};
